import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { RoomLayoutEntityType } from "building-types/roomLayouts/roomLayoutTypes";
import type { DocRoomLayoutEntityFields } from "./DocRoomLayoutEntityFields";

export const roomLayoutEligibleEntityTypes: {
  [key in RoomLayoutEntityType]: boolean;
} = {
  ANNOTATION: true,
  CASEWORK: true,
  OPENING: true,
  PROP_INSTANCE: true,
  CONTENT_TEMPLATE_INSTANCE: true,
};

export const roomLayoutEntityTypeToDocTableName: {
  [type in RoomLayoutEntityType]: keyof DocRoomLayoutEntityFields;
} = {
  ANNOTATION: "annotation",
  CASEWORK: "casework",
  OPENING: "openings",
  PROP_INSTANCE: "propInstances",
  CONTENT_TEMPLATE_INSTANCE: "contentTemplateInstances",
};

export function isRoomLayoutEligibleDocEntityHandle(handle: DocEntityHandle) {
  return !!roomLayoutEligibleEntityTypes[handle?.type];
}
